import { render, staticRenderFns } from "./App.vue?vue&type=template&id=3c90c49a&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=3c90c49a&lang=less&scoped=true&"
import style1 from "./App.vue?vue&type=style&index=1&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3c90c49a",
  null
  
)

component.options.__file = "App.vue"
export default component.exports